import { useState, Fragment, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useUser } from "../../utils/UserContext";
import config from '../../utils/config';
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { CircularProgress } from "@mui/material";
import { LoadingButton } from "@mui/lab";

import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";

const steps = ["Etape 1", "Etape 2", "Etape 3"];

const UpdateProfesseur = () => {
  const navigate = useNavigate();
  const { userInfos, setUserInfos } = useUser();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [dateNaissance, setDateNaissance] = useState("");
  const [ville, setVille] = useState("");
  const [villeResidence, setVilleResidence] = useState("");
  const [arrondissementResidence, setArrondissementResidence] = useState("");
  const [quartierResidence, setQuartierResidence] = useState("");
  const [adresse, setAdresse] = useState("");
  const [telephone1, setTelephone1] = useState("");
  const [telephone2, setTelephone2] = useState("");
  const [sexe, setSexe] = useState("");

  const [dernierDiplome, setDernierDiplome] = useState("");
  const [diplomaDetail, setDiplomaDetail] = useState("");
  const [cyclesEnseignement, setCyclesEnseignement] = useState([]);
  const [experienceParCycle, setExperienceParCycle] = useState({});
  const [referencesPro, setReferencesPro] = useState([{ name: '', number: '' }]);
  const [email, setEmail] = useState("");

  const [quartiersAccessibles, setQuartiersAccessibles] = useState([]);
  const [typePieceIdentite, setTypePieceIdentite] = useState("");
  const [pieceIdentite, setPieceIdentite] = useState(null);
  const [joursDisponibles, setJoursDisponibles] = useState("");
  const [matieresGeneralesEnseignables, setMatieresGeneralesEnseignables] = useState("");
  const [classesGeneralesEnseignables, setClassesGeneralesEnseignables] = useState("");
  const [periodeJournee, setPeriodeJournee] = useState("");
  const [diplomeFichier, setDiplomeFichier] = useState(null);

  const [activeStep, setActiveStep] = useState(0);
  const [showBtn, setShowBtn] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");


  // Pré-remplir avec les données du professeur (userInfos = réponse login / détail)
  useEffect(() => {
    if (!userInfos) return;
    setFirstName(userInfos.first_name || "");
    setLastName(userInfos.last_name || "");
    // date_naissance peut être une string "YYYY-MM-DD" ou un autre type selon l'API
    // On sécurise en la convertissant en string puis en gardant uniquement la date.
    setDateNaissance(userInfos.date_naissance ? String(userInfos.date_naissance).slice(0, 10) : "");
    setVille(userInfos.ville || "");
    setVilleResidence(userInfos.ville_residence || "");
    setArrondissementResidence(userInfos.arrondissement_residence || "");
    setQuartierResidence(userInfos.quartier_residence || "");
    setAdresse(userInfos.adresse || "");
    setTelephone1(userInfos.telephone1 || "");
    setTelephone2(userInfos.telephone2 || "");
    setSexe(userInfos.sexe || "");
    setEmail(userInfos.email || "");
    setDernierDiplome(userInfos.dernier_diplome || "");
    setDiplomaDetail(userInfos.diploma_detail || "");
    setTypePieceIdentite(userInfos.type_piece_identite || "");
    setJoursDisponibles(userInfos.jours_disponibles || "");
    setClassesGeneralesEnseignables(typeof userInfos.classes_generales_enseignables === 'string' ? userInfos.classes_generales_enseignables : (userInfos.classes_generales_enseignables ? String(userInfos.classes_generales_enseignables) : ""));

    const cycles = userInfos.cycles_enseignement;
    if (Array.isArray(cycles)) setCyclesEnseignement(cycles);
    else if (cycles) setCyclesEnseignement([].concat(cycles));

    const expCycle = userInfos.experience_par_cycle;
    if (expCycle && typeof expCycle === 'object' && !Array.isArray(expCycle)) setExperienceParCycle(expCycle);

    const refs = userInfos.references_pro;
    if (Array.isArray(refs) && refs.length) {
      setReferencesPro(refs.map((r) => (typeof r === 'object' ? { name: r.name || '', number: r.number || r || '' } : { name: '', number: String(r) })));
    }

    const quartiers = userInfos.quartiers_accessibles;
    if (Array.isArray(quartiers)) setQuartiersAccessibles(quartiers);
    else if (quartiers) setQuartiersAccessibles([].concat(quartiers));

    const matieres = userInfos.matieres_generales_enseignables;
    if (typeof matieres === 'object' && matieres !== null) {
      setMatieresGeneralesEnseignables(JSON.stringify(matieres));
    } else if (typeof matieres === 'string') setMatieresGeneralesEnseignables(matieres);

    const periode = userInfos.periode_journee;
    if (typeof periode === 'object' && periode !== null) {
      setPeriodeJournee(JSON.stringify(periode));
    } else if (typeof periode === 'string') setPeriodeJournee(periode || "");
  }, [userInfos]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    setIsLoading(true);
    formData.append("first_name", firstName);
    formData.append("last_name", lastName);
    formData.append("date_naissance", dateNaissance);
    formData.append("adresse", adresse || "");
    formData.append("ville", ville);
    formData.append("ville_residence", villeResidence || "");
    formData.append("arrondissement_residence", arrondissementResidence || "");
    formData.append("quartier_residence", quartierResidence || "");
    formData.append("telephone1", telephone1);
    formData.append("telephone2", telephone2 || "");
    formData.append("sexe", sexe);
    formData.append("email", email || "");
    formData.append("username", telephone1);
    formData.append("cycles_enseignement", JSON.stringify(cyclesEnseignement));
    formData.append("experience_par_cycle", JSON.stringify(experienceParCycle));
    const referencesPayload = (referencesPro || [])
      .map((r) => {
        if (typeof r === "object" && r !== null) {
          return { name: r?.name || "", number: r?.number || "" };
        }
        return { name: "", number: String(r || "") };
      })
      .filter((ref) => ref.number);
    formData.append("references_pro", JSON.stringify(referencesPayload));
    formData.append("quartiers_accessibles", JSON.stringify(quartiersAccessibles));
    formData.append("dernier_diplome", dernierDiplome);
    formData.append("diploma_detail", diplomaDetail);
    formData.append("type_piece_identite", typePieceIdentite);
    if (diplomeFichier) formData.append("diplome_fichier", diplomeFichier);
    if (pieceIdentite) formData.append("piece_identite", pieceIdentite);
    formData.append("jours_disponibles", joursDisponibles || "");
    formData.append("classes_generales_enseignables", classesGeneralesEnseignables || "");
    formData.append("matieres_generales_enseignables", matieresGeneralesEnseignables || "");
    formData.append("periode_journee", periodeJournee || "");

    const url = `${config.apiUrl.replace(/\/+$/, '')}/comptes/update/professeur/${userInfos.id}`;

    fetch(url, {
      method: "PUT",
      body: formData,
      headers: { 'Authorization': `Bearer ${userInfos.token}` },
    })
      .then((response) => response.json().then((data) => ({ ok: response.ok, status: response.status, data })))
      .then(({ ok, data }) => {
        if (ok) {
          localStorage.setItem("user", JSON.stringify(data));
          setUserInfos(data);
          setActiveStep(0);
          toast.success('Mise à jour réussie 😊!', {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
          });
          navigate("/profile");
        } else {
          setError(data.message || "Une erreur s'est produite, veuillez réessayer.");
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setError("Une erreur est survenue, veuillez réessayer plus tard");
        console.log("Erreur => ", err);
        setIsLoading(false);
      });
  };

  const handleNext = (e) => {
    e.preventDefault();
    setActiveStep((prev) => prev + 1);
  };

  const handleBack = (e) => {
    e.preventDefault();
    setActiveStep((prev) => prev - 1);
  };

  const handleReset = () => setActiveStep(0);

  if (!userInfos) return null;

  return (
    <section className="signup-area">
      <ToastContainer />
      <div className="container">
        <div className="row align-items-center">
          <div className="col-12 col-md-8 offset-md-2">
            <div className="signup-form">
              <h2 className="text-center" style={{ fontFamily: 'arial' }}>Modification du profil professeur</h2>
              <p className="text-center text-muted small">Mêmes champs que lors de l&apos;inscription — Étape 1, 2 et 3</p>
              <LoadingButton />
              <Box sx={{ width: "100%", top: "50%" }}>
                <Stepper sx={{ mt: 4 }} activeStep={activeStep}>
                  {steps.map((label, index) => (
                    <Step key={index}>
                      <StepLabel>{label}</StepLabel>
                    </Step>
                  ))}
                </Stepper>

                {activeStep === steps.length ? (
                  <Fragment>
                    <Typography sx={{ mt: 2, mb: 1 }}>Votre compte a bien été modifié</Typography>
                    <Box sx={{ display: "flex", flexDirection: "row" }}>
                      <Box sx={{ flex: "1 1 auto" }} />
                      <Button onClick={handleReset}>Réinitialiser</Button>
                    </Box>
                  </Fragment>
                ) : (
                  <Fragment>
                    <form method="post" className="form-group">
                      {activeStep === 0 ? (
                        <Step1
                          firstName={firstName}
                          lastName={lastName}
                          dateNaissance={dateNaissance}
                          adresse={adresse}
                          ville={ville}
                          villeResidence={villeResidence}
                          setVilleResidence={setVilleResidence}
                          arrondissementResidence={arrondissementResidence}
                          setArrondissementResidence={setArrondissementResidence}
                          quartierResidence={quartierResidence}
                          setQuartierResidence={setQuartierResidence}
                          setError={setError}
                          sexe={sexe}
                          setSexe={setSexe}
                          setFirstName={setFirstName}
                          setLastName={setLastName}
                          setDateNaissance={setDateNaissance}
                          setAdresse={setAdresse}
                          setVille={setVille}
                          setShowBtn={setShowBtn}
                          telephone1={telephone1}
                          telephone2={telephone2}
                          setTelephone1={setTelephone1}
                          setTelephone2={setTelephone2}
                        />
                      ) : activeStep === 1 ? (
                        <Step2
                          setShowBtn={setShowBtn}
                          dernierDiplome={dernierDiplome}
                          setDernierDiplome={setDernierDiplome}
                          diplomaDetail={diplomaDetail}
                          setDiplomaDetail={setDiplomaDetail}
                          diplomeFichier={diplomeFichier}
                          setDiplomeFichier={setDiplomeFichier}
                          cyclesEnseignement={cyclesEnseignement}
                          setCyclesEnseignement={setCyclesEnseignement}
                          experienceParCycle={experienceParCycle}
                          setExperienceParCycle={setExperienceParCycle}
                          referencesPro={referencesPro}
                          setReferencesPro={setReferencesPro}
                          email={email}
                          setEmail={setEmail}
                          isEdit={true}
                        />
                      ) : (
                        <Step3
                          ville={ville}
                          quartiersAccessibles={quartiersAccessibles}
                          setQuartiersAccessibles={setQuartiersAccessibles}
                          typePieceIdentite={typePieceIdentite}
                          setTypePieceIdentite={setTypePieceIdentite}
                          pieceIdentite={pieceIdentite}
                          setPieceIdentite={setPieceIdentite}
                          joursDisponibles={joursDisponibles}
                          setJoursDisponibles={setJoursDisponibles}
                          matieresGeneralesEnseignables={matieresGeneralesEnseignables}
                          setMatieresGeneralesEnseignables={setMatieresGeneralesEnseignables}
                          classesGeneralesEnseignables={classesGeneralesEnseignables}
                          setClassesGeneralesEnseignables={setClassesGeneralesEnseignables}
                          periodeJournee={periodeJournee}
                          setPeriodeJournee={setPeriodeJournee}
                          setShowBtn={setShowBtn}
                          setError={setError}
                          isEdit={true}
                        />
                      )}

                      <Box sx={{ display: "flex", flexDirection: "row", pt: 2, justifyContent: 'space-between' }}>
                        {activeStep > 0 && (
                          <LoadingButton
                            sx={{ backgroundColor: '#1d42d9', borderRadius: 50, height: 50, marginTop: 2, padding: 4, color: 'white' }}
                            onClick={handleBack}
                          >
                            Précédent
                          </LoadingButton>
                        )}
                        <Box sx={{ flex: "1 1 auto" }} />
                        {activeStep === steps.length - 1 ? (
                          showBtn && (
                            <LoadingButton
                              loading={isLoading}
                              variant="contained"
                              loadingIndicator={<CircularProgress color="inherit" size={30} />}
                              sx={{ backgroundColor: '#1d42d9', borderRadius: 50, height: 50, marginTop: 2, padding: 4, color: 'white' }}
                              onClick={handleSubmit}
                            >
                              Mettre à jour
                            </LoadingButton>
                          )
                        ) : (
                          showBtn && (
                            <LoadingButton
                              sx={{ backgroundColor: '#1d42d9', borderRadius: 50, height: 50, marginTop: 2, padding: 4, color: 'white' }}
                              onClick={handleNext}
                            >
                              Suivant
                            </LoadingButton>
                          )
                        )}
                      </Box>
                      <p style={{ color: "red" }}>{error}</p>
                    </form>
                  </Fragment>
                )}
              </Box>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UpdateProfesseur;
